export default __webpack_public_path__ + "static/media/left.dc676410.svg";